module.exports = __webpack_public_path__ + "images/cebsblogo_white.1788405320306.png";